const state = {
    inventoryitems: [],
}

const getters = {

    viewinventoryitems:(state)=> {
        return state.inventoryitems.map(function(el) {
            var o = Object.assign({}, el);
            o.quantity = 0;
            return o;
          })
    },
    inventoryitems: state => state.inventoryitems
}

const actions = {
    // LOGIN REGISTERED USER
    createInventoryItem({commit},payload){
        firebase.database().ref('inventory').push(payload)
        .then(()=>{
            commit("setNotifications",{message:'Item created successfully',type:'success'})
        })
        .catch(error=>{
            commit("setNotifications",{message:error.message,type:'error'})
        })

    },
    updateInventoryItem({commit},payload) {
        let id=payload.id
        delete payload.id
        firebase.database().ref('inventory').child(id).update(payload)
        .then(()=>{
            commit("setNotifications",{message:'Item updated successfully',type:'success'})
        })
        .catch(error=>{
            commit("setNotifications",{message:error.message,type:'error'})
        })
    },
    fetchInventoryItems({commit},payload){
        firebase.database().ref('inventory').on('value', snapshot => {
            commit('setAllItems', snapshot.val())
        })
    },

 
}

const mutations = {

    setAllItems: (state, payload) => {
        let items_Array=[]
        for(let key in payload) {
            payload[key].id=key
            items_Array.push(payload[key])
        }
        state.inventoryitems=items_Array
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}